import { FileWithShare, isShared } from "@/lib/supabase/supabaseTypes";
import { ShareDialog } from "../share-dialog/share-dialog.component";
import { useCentralStore } from "@/dentlab/src/store/Central";
import { showNotification } from "@/dentlab/src/store/Central/selectors";
import { sendSharedFileEmail } from "@/lib/email";
import { buildShareLink } from "@/lib/utils/build-share-link";
import { environment } from "@/dentlab/src/lib/utils/environment";

// This component is used to share files (non-pdf files) relating to a patient or a job
//
// If a job or patient is set the corresponding job or patient will be attached to the file
// in dentconnect
export const ShareFileButton = ({
	file,
	open,
	setOpen,
	handleShare,
}: {
	file: FileWithShare;
	open: boolean;
	setOpen: (val: boolean) => void;
	handleShare: () => void;
}) => {
	const {
		connectedOrganizationEmail,
		organizationId,
		connectedOrganizationType,
	} = useCentralStore((state) => ({
		connectedOrganizationEmail: state.connectedOrganizationEmail,
		organizationId: state.organization?.id ?? "",
		connectedOrganizationType: state.connectedOrganizationType,
	}));

	const handleNotify = async (message: string) => {
		if (!connectedOrganizationEmail) {
			showNotification({
				message: "Es wurde keine E-Mail-Adresse für das Labor gefunden",
				type: "error",
			});
			return;
		}

		if (!connectedOrganizationType) {
			showNotification({
				message: "Der Typ der verbundenen Organisation ist unbekannt. Bitte laden Sie die Seite neu und versuchen Sie es erneut.",
				type: "error",
			});
			return;
		}

		const link = file.id
			? buildShareLink({
					fileId: file.id,
					recipientEmail: connectedOrganizationEmail,
					senderOrgId: organizationId,
					recipientOrgType: connectedOrganizationType,
					dentconnectUrl: environment.VITE_DENTCONNECT_URL,
					jobId: file.job_id ?? undefined,
				})
			: "";

		sendSharedFileEmail({
			recipientEmail: connectedOrganizationEmail,
			fileName: file.file_name ?? "Kein Dateiname",
			link,
			message,
		});

		setOpen(false);
	};
	const shareDialog = (
		<ShareDialog
			open={open}
			onClose={() => setOpen(false)}
			entityName={file?.file_name ?? "Datei"}
			shared={isShared(file)}
			onShare={handleShare}
			onUnshare={() => {}}
			onNotify={handleNotify}
		/>
	);

	return <>{shareDialog}</>;
};
